import React from 'react'
import styled, { css } from 'styled-components'

import colors from '../../../vars/colors'
import breakpoints from '../../../vars/breakpoints'
import gutters from '../../../vars/gutters'

export const CitiesWrapper = styled.section`
    margin-bottom: 80px;

    @media (min-width: ${breakpoints['bp-desktop']}) {
        display: none;
    }
`

export const CitiesCompletedWrapper = styled.div`
    position: relative;

    .title {
        h2 {
            margin-bottom: 5px;
        }

        p {
            color: ${colors['medium-grey']};
            font-family: 'OneDot', sans-serif;
            font-size: 12px;
            font-weight: bold;
            letter-spacing: 2.9px;
            margin-bottom: 20px;
            text-transform: uppercase;
        }

        svg {
            fill: ${colors['lipstick']};
            height: .75rem;
        }
    }

    .completed-cities__list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 16px;
    }

    .completed-cities__item {
        flex-basis: 50%;
        margin-bottom: 20px;
    }

    .cityAndState {
        text-transform: uppercase;
        a {
            transition: color 300ms ease-in;
        }
        .city,
        .state {
            font-size: 15px;
            a {
                color: ${colors['medium-grey']};
                display: inline-block;
                text-decoration: none;
            }
        }
        .city {
            color: ${colors['lipstick']};
            font-family: 'OneDotCd', sans-serif;
            font-weight: bold;
            letter-spacing: 2px;
            line-height: 1.35;
            text-align: left;
            a {
                color: ${colors['lipstick']};
                transition: transform .33s ease-out;
            }
            &.current {
                a {
                    color: ${colors['lipstick']};
                }
            }
            svg {
                fill: #e11d38;
                height: .75rem;
                margin-left: -20px;
                margin-right: 0px;
            }
        }
        .state {
            color: ${colors['medium-grey']};
            font-family: 'OneDotCd', sans-serif;
            font-weight: bold;
            line-height: 2.16;
            letter-spacing: 2px;
            a {
                transition: transform .5s ease-out;
            }
        }
        &:hover {
            .city {
                a {
                    color: ${colors['grey-brown']};
                    transform: translateX(1rem);
                }
            }
            .state {
                a {
                    transform: translateX(1rem);
                }
            }
        }
    }
`

export const CitiesUpcomingWrapper = styled.div`
    @media (max-width: ${breakpoints['bp-mobile']}) {
        margin-top: 40px;
    }

    @media (min-width: ${breakpoints['bp-mobile']} and max-width: ${breakpoints['bp-tablet']}) {
        margin-top: 85px;
    }

    .upcoming-cities__list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 16px;
    }

    .upcoming-cities__item {
        flex-basis: 50%;
        margin-bottom: 20px;
    }

    .cityAndState {
        font-size: 15px;
        text-transform: uppercase;

        .city {
            color: ${colors['lipstick']};
            display: block;
            font-family: 'OneDotCd', sans-serif;
            font-weight: bold;
            letter-spacing: 2px;
            line-height: 1.35;
            text-align: left;
        }
        .state {
            color: ${colors['medium-grey']};
            font-family: 'OneDotCd', sans-serif;
            font-weight: bold;
            line-height: 2.16;
            letter-spacing: 2px;
        }
    }

    .teaser-text {
        color: ${colors['medium-grey']};
        font-family: 'OneDot', sans-serif;
        font-size: 12px;
        font-weight: bold;
        line-height: 1.2;
        letter-spacing: 2.9px;
        margin-bottom: 20px;
        text-transform: uppercase;
    }
`



// WEBPACK FOOTER //
// ./src/components/modules/CitiesLists/styled-components.js